import { useCallback, useState } from "react";

const toggleIn = (value) => (prev) =>
  prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value];

// Filter state shared by SearchPage and the home feed (rendered by
// common-components/filters/FilterPanel). Sort is deliberately not part of
// this: search keeps one per tab, the feed has a single optional one.
// Mirrors ngwaahia-mobile/utils/hooks/useCatalogFilters.js.
const useCatalogFilters = ({
  initialCategories = [],
  initialDeliveryMethods = [],
  initialPaymentMethods = [],
  initialPaymentTimings = [],
} = {}) => {
  const [selectedCategories, setSelectedCategories] =
    useState(initialCategories);
  const [selectedDeliveryMethods, setSelectedDeliveryMethods] = useState(
    initialDeliveryMethods,
  );
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState(
    initialPaymentMethods,
  );
  const [selectedPaymentTimings, setSelectedPaymentTimings] = useState(
    initialPaymentTimings,
  );
  const [locationCountry, setLocationCountry] = useState(null);
  const [locationState, setLocationState] = useState(null);

  const toggleCategory = useCallback(
    (value) => setSelectedCategories(toggleIn(value)),
    [],
  );
  const toggleDeliveryMethod = useCallback(
    (value) => setSelectedDeliveryMethods(toggleIn(value)),
    [],
  );
  const togglePaymentMethod = useCallback(
    (value) => setSelectedPaymentMethods(toggleIn(value)),
    [],
  );
  const togglePaymentTiming = useCallback(
    (value) => setSelectedPaymentTimings(toggleIn(value)),
    [],
  );
  const setLocation = useCallback(({ country, state }) => {
    setLocationCountry(country || null);
    setLocationState(state || null);
  }, []);
  const clearLocation = useCallback(() => {
    setLocationCountry(null);
    setLocationState(null);
  }, []);
  const clearAll = useCallback(() => {
    setSelectedCategories([]);
    setSelectedDeliveryMethods([]);
    setSelectedPaymentMethods([]);
    setSelectedPaymentTimings([]);
    setLocationCountry(null);
    setLocationState(null);
  }, []);

  const hasLocation = !!(locationState || locationCountry);
  const hasActiveFilters =
    selectedCategories.length > 0 ||
    selectedDeliveryMethods.length > 0 ||
    selectedPaymentMethods.length > 0 ||
    selectedPaymentTimings.length > 0 ||
    hasLocation;

  return {
    selectedCategories,
    selectedDeliveryMethods,
    selectedPaymentMethods,
    selectedPaymentTimings,
    locationCountry,
    locationState,
    hasLocation,
    hasActiveFilters,
    toggleCategory,
    toggleDeliveryMethod,
    togglePaymentMethod,
    togglePaymentTiming,
    setLocation,
    clearLocation,
    clearAll,
  };
};

export default useCatalogFilters;
